module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/fixedplugin/fixedplugin.component.css
// module id = ./src/app/shared/fixedplugin/fixedplugin.component.css
// module chunks = main